const LOAD_EVENTS_V3_FETCH = "events::v3::fetch";
const LOAD_EVENTS_V3_SUCCESS = "events::v3::fetch::success";
const LOAD_EVENTS_V3_NAME = "events::v3::fetch::all-event-names";
const UNLOAD_EVENTS_V3 = "events::v3::unload";

function unloadEventsV3Action() {
  return {
    type: UNLOAD_EVENTS_V3,
  };
}

export {
  unloadEventsV3Action,
  LOAD_EVENTS_V3_FETCH,
  LOAD_EVENTS_V3_SUCCESS,
  LOAD_EVENTS_V3_NAME,
  UNLOAD_EVENTS_V3,
};
